import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { Heading } from "V2.0/common/heading";
import { useEffect, useState } from "react";
import CampaignsLoading from "V2.0/HomePages/HomeCampaign/common/CampaignLoading";
import CampaignsEmpty from "V2.0/HomePages/HomeCampaign/common/CampaignEmpty";
import CampaignsNotFound from "V2.0/HomePages/HomeCampaign/common/CampaignsNotFound";
import CampaignObjectsTable, {
  campaignObjectColumns,
} from "V2.0/HomePages/HomeCampaign/common/CampaignObjectsTable";
import useBulkCampaignObjectsPaginated from "./BulkCampaign/useBulkCampaignObjectsPaginated";
import Pagination from "V2.0/components/Pagination";
import CampaignReportModal from "V2.0/HomePages/HomeCampaign/common/CampaignReportModal";

// Old unpaginated version. Replaced below with useBulkCampaignObjectsPaginated + a Pagination
// control, an assistant-name subheading, and a per-contact report drill-down (CampaignReportModal) —
// ported from Frontend. (bulk-campaign-report-ui-port, Task 6)
// import useBulkCampaignObjects from "./BulkCampaign/useBulkCampaignObjects";
//
// export default function BulkCampaignPage(props) {
//   const { workspaceId, bulkCampaign, onBack } = props;
//
//   const {
//     bulkCampaignObjects,
//     isBulkCampaignObjectsLoading,
//     fetchBulkCampaignObjects,
//   } = useBulkCampaignObjects(workspaceId, bulkCampaign._id);
//
//   useEffect(() => {
//     if (workspaceId && bulkCampaign) {
//       fetchBulkCampaignObjects();
//     }
//   }, [workspaceId, bulkCampaign]);
//
//   return (
//     <div className="flex flex-col gap-y-4 p-4 h-full">
//       <div className="flex items-center w-full gap-x-2">
//         <ArrowLeftIcon
//           className="size-4 text-zinc-500 cursor-pointer hover:text-zinc-800"
//           onClick={onBack}
//         />
//         <Heading>{bulkCampaign.name}</Heading>
//       </div>
//
//       {isBulkCampaignObjectsLoading && <CampaignsLoading />}
//
//       {!isBulkCampaignObjectsLoading && bulkCampaignObjects.length === 0 && (
//         <CampaignsNotFound />
//       )}
//
//       {!isBulkCampaignObjectsLoading && bulkCampaignObjects.length > 0 && (
//         <CampaignObjectsTable campaignObjects={bulkCampaignObjects} />
//       )}
//     </div>
//   );
// }

const COLUMN_BAND_HEIGHT = "lg:h-[44rem]";

export default function BulkCampaignPage(props) {
  const {
    workspaceId,
    bulkCampaign,
    onBack,
    assistantsRecord,
    isViewOnly,
  } = props;

  const {
    bulkCampaignObjects,
    bulkCampaignObjectsPagination,
    isBulkCampaignObjectsLoading,
    fetchBulkCampaignObjectsPaginated,
  } = useBulkCampaignObjectsPaginated(workspaceId, bulkCampaign._id);

  const [reportCampaign, setReportCampaign] = useState(null);

  useEffect(() => {
    if (workspaceId && bulkCampaign) {
      fetchBulkCampaignObjectsPaginated();
    }
  }, [workspaceId, bulkCampaign]);

  function handlePageChange(page) {
    if (page >= 1 && page <= bulkCampaignObjectsPagination.totalPages) {
      fetchBulkCampaignObjectsPaginated(page, true);
    }
  }

  const hasRows = !isBulkCampaignObjectsLoading && bulkCampaignObjects.length > 0;

  const assistantName = assistantsRecord?.[bulkCampaign.assistant]?.name;

  return (
    <div className="flex flex-col gap-y-6 p-4">
      <div className="flex w-full items-start gap-x-2">
        <ArrowLeftIcon
          className="mt-1.5 size-4 shrink-0 text-zinc-500 cursor-pointer hover:text-zinc-800"
          onClick={onBack}
        />
        <div className="min-w-0">
          <Heading>{bulkCampaign.name}</Heading>
          {assistantName && (
            <p className="mt-0.5 truncate text-sm text-zinc-500">{assistantName}</p>
          )}
        </div>
      </div>
      <div className={`flex flex-col gap-6 ${COLUMN_BAND_HEIGHT}`}>
        <div className="flex min-w-0 flex-1 flex-col gap-y-3">
          {isBulkCampaignObjectsLoading && (
            <CampaignsLoading
              columns={campaignObjectColumns({ hideAssistant: true })}
              rows={bulkCampaignObjectsPagination.limit}
              constrainHeight={false}
            />
          )}

          {!isBulkCampaignObjectsLoading && bulkCampaignObjects.length === 0 && (
            <CampaignsNotFound />
          )}

          {hasRows && (
            <div className="min-h-0 overflow-y-auto">
              <CampaignObjectsTable
                campaignObjects={bulkCampaignObjects}
                assistantsRecord={assistantsRecord}
                isViewOnly={isViewOnly}
                hideAssistant
                onCampaignReport={setReportCampaign}
              />
            </div>
          )}

          {hasRows && (
            <div className="mt-auto shrink-0">
              <Pagination
                currentPage={bulkCampaignObjectsPagination.currentPage}
                totalItems={bulkCampaignObjectsPagination.totalCount}
                itemsPerPage={bulkCampaignObjectsPagination.limit}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
      {reportCampaign && (
        <CampaignReportModal
          isOpen={!!reportCampaign}
          onClose={() => setReportCampaign(null)}
          workspaceId={workspaceId}
          campaign={reportCampaign}
          assistantsRecord={assistantsRecord}
        />
      )}
    </div>
  );
}
